window.initRecentlyViewedDrag = function(scroller) {
  if (!scroller || scroller.dataset.dragInit === 'true') return;
  scroller.dataset.dragInit = 'true';
  var isDown = false;
  var startX = 0;
  var initialScrollLeft = 0;
  var hasMoved = false;

  function stopDrag() {
    if (!isDown) return;
    isDown = false;
    scroller.classList.remove('is-dragging');
    setTimeout(function() {
      hasMoved = false;
    }, 50);
  }

  scroller.addEventListener('dragstart', function(e) {
    e.preventDefault();
  });

  scroller.addEventListener('mousedown', function(e) {
    if (e.button !== 0) return;
    isDown = true;
    hasMoved = false;
    startX = e.pageX;
    initialScrollLeft = scroller.scrollLeft;
    scroller.classList.add('is-dragging');
  });

  window.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    if (e.buttons !== 1) {
      stopDrag();
      return;
    }
    var currentX = e.pageX;
    var walk = currentX - startX;
    if (Math.abs(walk) > 4) {
      hasMoved = true;
    }
    scroller.scrollLeft = initialScrollLeft - walk;
  });

  window.addEventListener('mouseup', stopDrag);
  window.addEventListener('mouseleave', stopDrag);
  window.addEventListener('blur', stopDrag);

  scroller.addEventListener('click', function(e) {
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
};

if (!window.Eurus.loadedScript.has('recently-viewed.js')) {
  window.Eurus.loadedScript.add('recently-viewed.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecently', {
        show: false,
        productsToShow: 0,
        productsToShowMax: 20,
        hasLoaded: false,
        init() {
          var el = document.getElementById('shopify-section-recently-viewed');
          if (el) {
            var val = parseInt(el.getAttribute("x-products-to-show"), 10);
            if (!isNaN(val) && val > 0) {
              this.productsToShow = val;
            }
            var scroller = el.querySelector('.recently-viewed-scroller');
            if (scroller && window.initRecentlyViewedDrag) {
              window.initRecentlyViewedDrag(scroller);
            }
          }
        },
        showProductRecently() {
          /* Only ever hides. The server renders this section with no cards, because
             there is no search context on first load, so revealing it here would
             flash an empty section until the fetch returns. Revealing is left to
             getProductRecently, once real cards are in the DOM. */
          let list = [];
          try {
            list = JSON.parse(localStorage.getItem("recently-viewed") || "[]");
          } catch (e) {
            list = [];
          }
          if (!Array.isArray(list) || list.length < 2) {
            this.show = false;
          }
        },
        setProduct(productViewed) {
          if (!productViewed) return;
          const viewedStr = String(productViewed).trim();
          if (!viewedStr) return;
          let productList = [];
          if (localStorage.getItem("recently-viewed")?.length) {
            try {
              productList = JSON.parse(localStorage.getItem("recently-viewed") || "[]");
            } catch (e) {
              productList = [];
            }
            if (!Array.isArray(productList)) productList = [];
            productList = productList.filter(p => String(p).trim() !== viewedStr).filter((p, i) => i < this.productsToShowMax);
            if (!productList.length) {
              this.show = false;
            }
            let newData = [viewedStr, ...productList];
            localStorage.setItem('recently-viewed', JSON.stringify(newData));
          } else {
            this.show = false;
            localStorage.setItem('recently-viewed', JSON.stringify([viewedStr]));
          }
        },
        getProductRecently(sectionId, productId, productsToShowParam) {
          const isDesignMode = (window.Shopify && window.Shopify.designMode) || document.body.classList.contains('shopify-design-mode');
          if (this.hasLoaded && !isDesignMode) return;

          const el = document.getElementById("shopify-section-recently-viewed");
          let limit = parseInt(productsToShowParam, 10);
          if (isNaN(limit) || limit <= 0) {
            if (el) {
              limit = parseInt(el.getAttribute("x-products-to-show"), 10);
            }
          }
          if (isNaN(limit) || limit <= 0) {
            limit = parseInt(this.productsToShow, 10);
          }
          if (isNaN(limit) || limit <= 0) {
            limit = 4;
          }
          this.productsToShow = limit;

          let products = [];
          if (localStorage.getItem("recently-viewed")?.length) {
            try {
              products = JSON.parse(localStorage.getItem("recently-viewed") || "[]");
            } catch (e) {
              products = [];
            }
            if (!Array.isArray(products)) products = [];
            const currentIdStr = productId ? String(productId).trim() : '';
            if (currentIdStr) {
              products = products.filter(p => String(p).trim() !== currentIdStr);
            }
            products = products.map(p => String(p).trim()).slice(0, limit);
          } else {
            this.show = false;
            return;
          }
          /* Only show if at least 2 products to display */
          if (!products || products.length < 2) {
            this.show = false;
            return;
          }
          this.hasLoaded = true;
          let query = products.map(value => "id:" + value).join(' OR ');
          var search_url = `${Shopify.routes.root}search?section_id=${ sectionId }&type=product&q=${query}`;
          fetch(search_url).then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              console.log(error);
              throw error;
            }
    
            return response.text();
          })
          .then((text) => {
            const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
            const fetchedSection = parsedDoc.getElementById('shopify-section-recently-viewed');
            if (!fetchedSection) return;

            const scroller = fetchedSection.querySelector('.recently-viewed-scroller');
            if (scroller) {
              const itemElements = Array.from(scroller.querySelectorAll('.recently-viewed-item'));
              const itemsById = {};

              itemElements.forEach((itemEl) => {
                let id = itemEl.getAttribute('data-product-id');
                if (!id) {
                  const card = itemEl.querySelector('[data-product_id], [data-product-id]');
                  if (card) {
                    id = card.getAttribute('data-product_id') || card.getAttribute('data-product-id');
                  }
                }
                if (!id) {
                  const cardEl = itemEl.querySelector('[x-data*="xProductCard"]');
                  if (cardEl) {
                    const match = cardEl.getAttribute('x-data')?.match(/'([^']+)'\s*\)$/);
                    if (match) id = match[1];
                  }
                }
                if (id) {
                  itemsById[String(id).trim()] = itemEl;
                }
              });

              // Re-sort the scroller children in the exact chronological sequence of `products`
              // products array has the IDs ordered: [most_recent, 2nd_most_recent, 3rd_most_recent, ...]
              // and enforce the maximum products to show limit
              scroller.innerHTML = '';
              let appendedCount = 0;
              products.forEach((id) => {
                if (appendedCount >= limit) return;
                const cardEl = itemsById[String(id).trim()];
                if (cardEl) {
                  scroller.appendChild(cardEl);
                  appendedCount++;
                }
              });
            }

            el.innerHTML = fetchedSection.innerHTML;
            if (window.Alpine && typeof window.Alpine.initTree === 'function') {
              window.Alpine.initTree(el);
            }
            /* Stored ids can point at products that were deleted, unpublished or are
               outside this market, so the search can come back empty. The rendered
               cards are the only reliable signal. Show only if 2 or more products exist. */
            this.show = el.querySelectorAll('.recently-viewed-item').length >= 2;
            var activeScroller = el.querySelector('.recently-viewed-scroller');
            if (activeScroller && window.initRecentlyViewedDrag) {
              window.initRecentlyViewedDrag(activeScroller);
            }
          })
          .catch((error) => {
            this.hasLoaded = false;
            throw error;
          })
          .finally(() => {
            requestAnimationFrame(() => {
              window.yotpoWidgetsContainer?.initWidgets?.();
              if (window.WishlistEngine) {
                if (typeof window.WishlistEngine.init === 'function') window.WishlistEngine.init();
                if (typeof window.WishlistEngine.render === 'function') window.WishlistEngine.render();
                if (typeof window.WishlistEngine.setupWishlistButtons === 'function') window.WishlistEngine.setupWishlistButtons();
              }
              document.dispatchEvent(new CustomEvent('wishlist-engine:render'));
              document.dispatchEvent(new CustomEvent('wishlist:updated'));
            });
          });
        },
        clearStory() {
          var result = confirm('Are you sure you want to clear your recently viewed products?');
          if (result === true) {
            localStorage.removeItem("recently-viewed");
            this.show = false;
            this.hasLoaded = false;
          }
        }
      });

      if (!window.__recentlyViewedSectionLoadBound) {
        window.__recentlyViewedSectionLoadBound = true;
        document.addEventListener('shopify:section:load', (e) => {
          if (e.target && (e.target.id === 'shopify-section-recently-viewed' || e.target.querySelector('#shopify-section-recently-viewed'))) {
            if (window.Alpine && window.Alpine.store('xProductRecently')) {
              const store = window.Alpine.store('xProductRecently');
              store.hasLoaded = false;
              const el = document.getElementById('shopify-section-recently-viewed');
              if (el) {
                const val = parseInt(el.getAttribute('x-products-to-show'), 10);
                if (!isNaN(val) && val > 0) {
                  store.productsToShow = val;
                }
              }
            }
          }
        });
      }
    });
  });
}
